export default __webpack_public_path__ + "static/media/community.30051cce.svg";